/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_norm_faq_q3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Where do I find density and assay?`)
};

const es_norm_faq_q3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Dónde encuentro la densidad y el ensayo?`)
};

const de_norm_faq_q3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wo finde ich Dichte und Gehalt?`)
};

const nl_norm_faq_q3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Waar vind ik dichtheid en gehalte?`)
};

const fr_norm_faq_q3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Où trouver la densité et le titre ?`)
};

const it_norm_faq_q3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dove trovo densità e titolo?`)
};

const pt_br2_norm_faq_q3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Onde encontro a densidade e o teor?`)
};

const pt_norm_faq_q3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Onde encontro a densidade e o título?`)
};

const ja_norm_faq_q3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`密度とアッセイはどこで確認できますか？`)
};

const zh_norm_faq_q3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`从哪里获取密度和含量？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const norm_faq_q3 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.norm_faq_q3(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("norm_faq_q3", locale)
	if (locale === "en") return en_norm_faq_q3(inputs)
	if (locale === "es") return es_norm_faq_q3(inputs)
	if (locale === "de") return de_norm_faq_q3(inputs)
	if (locale === "nl") return nl_norm_faq_q3(inputs)
	if (locale === "fr") return fr_norm_faq_q3(inputs)
	if (locale === "it") return it_norm_faq_q3(inputs)
	if (locale === "pt-BR") return pt_br2_norm_faq_q3(inputs)
	if (locale === "pt") return pt_norm_faq_q3(inputs)
	if (locale === "ja") return ja_norm_faq_q3(inputs)
	return zh_norm_faq_q3(inputs)
};